import React from 'react';
import useToAmount from '../../hooks/use-to-amount.js';
import useToAsset from '../../hooks/use-to-asset.js';
import useToFiatAmount from '../../hooks/use-to-fiat-amount.js';
import useToSideLoading from '../../hooks/use-to-side-loading.js';
import AssetInput from '../input/index.js';
import { INPUT_MODE } from '../../constants.js';
import usePrefilledAmountId from '../../hooks/use-prefilled-amount-id.js';
const ToAssetInput = ({ Component, className, style, mode = INPUT_MODE.CRYPTO, disabled }, ref) => {
    const [toAsset] = useToAsset();
    const [toAmount, setToAmount, resetToAmount] = useToAmount();
    const [toFiatAmount, setToFiatAmount] = useToFiatAmount();
    const loading = useToSideLoading();
    const [, setPrefilledAmountId] = usePrefilledAmountId();
    return (React.createElement(AssetInput, { ref: ref, Component: Component, className: className, style: style, mode: mode, direction: "to", asset: toAsset, amount: toAmount, fiatAmount: toFiatAmount, setFiatAmount: setToFiatAmount, setAmount: setToAmount, loading: loading, setPrefilledAmountId: setPrefilledAmountId, resetAmount: resetToAmount, disabled: disabled }));
};
export default React.forwardRef(ToAssetInput);
